import React, { ReactElement } from 'react';
import TranslatedText from '../../../../components/atoms/translated_text';
import { Translations } from './configuration';
import { Button, Grid, Typography } from '@material-ui/core';
import { SchemeTypes } from '../../../../config';
import { ModalIDs } from '../../../../redux/reducers/gl_modal_reducer/types';
import AddIcon from '@material-ui/icons/Add';
import ModalActions from '../../../../redux/reducers/gl_modal_reducer/actions';
import { useDispatch } from 'react-redux';
import IdentificationInOtherEuCountriesTable from './components/datatable';

interface IProps {
  mode: 'VIEW' | 'EDIT';
  scheme_type?: SchemeTypes;
  is_agent?: boolean;
  isExcluded: boolean;
}

export default function IdentificationOfOtherEuCountries(
  props: IProps
): ReactElement {
  // console.log('Render IdentificationOfOtherEuCountries');
  const mode = props.mode;
  const isExcluded = props.isExcluded;
  const dispatch = useDispatch();
  const openModal = (modal_id: number, params = {}) => {
    dispatch(
      ModalActions.openModalAction({
        modalID: modal_id,
        params: params,
      })
    );
  };

  return (
    <div>
      <Grid container>
        <Grid item lg={6} xs={12}>
          <Typography variant="h5">
            <TranslatedText textMap={Translations.header} />
          </Typography>
        </Grid>
        <Grid item lg={6} xs={12} style={{ textAlign: 'right' }}>
          <Button
            type="button"
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
            onClick={() =>
              openModal(ModalIDs.MODAL_IDENTIFICATION_IN_OTHER_EU_COUNTRIES)
            }
            disabled={mode === 'VIEW' || isExcluded}
          >
            <TranslatedText textMap={Translations.add_header_button} />
          </Button>
        </Grid>
      </Grid>
      <p>
        <TranslatedText textMap={Translations.subtitle} />
      </p>
      <IdentificationInOtherEuCountriesTable mode={props.mode} />
    </div>
  );
}
